import React from 'react';
import { FormControl, InputLabel, OutlinedInput, FormHelperText, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { generateTestId } from 'app/functions';

export const HotTextArea = ({
  name,
  control,
  label,
  required = false,
  helperText,
  rules = {},
  minRows = 3,
  maxRows = 6,
  testID,
  ...rest
}) => {
  // If required is true, add it to the rules
  if (required && !rules.required) {
    rules.required = 'This field is required';
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          {label && (
            <InputLabel
              sx={{
                position: 'relative',
                transform: 'none',
                color: "text.inputLabel",
              }}
            >
              {label}
            </InputLabel>
          )}


          <TextField
            {...field}
            {...rest}
            label={null}
            error={!!error}
            testID={generateTestId(testID, `${name}-area`)}
            helperText={error ? error.message : helperText}
            multiline
            minRows={minRows} 
            maxRows={maxRows}

          />

        </FormControl>
      )}
    />
  );
};

export default HotTextArea; 